import React, { useState } from 'react';
import { authApi } from '../../api/phpApi';
import './LoginForm.css';
import logo from '../../assets/logo.svg';

const LoginForm = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('admin@iamar.ma');
  const [password, setPassword] = useState('admin123');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await authApi.login({
        email,
        password,
      });

      if (response && response.user) {
        onLoginSuccess(response.user);
      } else {
        setError('Échec de la connexion. Vérifiez vos identifiants.');
      }
    } catch (err) {
      setError(err.message || 'Une erreur est survenue lors de la connexion.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" style={{ fontFamily: 'Montserrat, sans-serif' }}>
      <div className="login-form">
        <div className="logo-container" style={{ textAlign: 'center', marginBottom: 20 }}>
          <img 
            src={logo} 
            alt="IAMAR Logo" 
            className="login-logo"
            style={{ maxHeight: 60, width: 'auto' }}
          />
          <h2 style={{ marginTop: 15, fontSize: '1.4rem', color: '#1b1e4f', fontWeight: 600 }}>
            Espace d'Administration
          </h2>
          <p style={{ color: '#6b7280', fontSize: '0.88rem', margin: '4px 0 0 0' }}>
            Connectez-vous pour gérer les informations et contenus du site
          </p>
        </div>
        
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Identifiant ou Email</label>
            <input
              type="text"
              id="email"
              placeholder="ex: admin ou admin@iamar.ma"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            />
          </div>

          {error && <div className="error-message" style={{ marginBottom: 15 }}>{error}</div>}

          <button
            type="submit"
            disabled={loading}
            className="login-button"
            style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, cursor: 'pointer' }}
          >
            {loading ? 'Connexion en cours...' : 'Se connecter'}
          </button>

      
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
